// import { createContext, useContext, useState, ReactNode } from 'react'

// const ModalContext = createContext<{
//   showModal: (content: ReactNode) => void
//   hideModal: () => void
//   content: ReactNode | null
//   visible: boolean
// }>({
//   showModal: () => {},
//   hideModal: () => {},
//   content: null,
//   visible: false,
// })

// export const ModalProvider = ({ children }: { children: ReactNode }) => {
//   const [visible, setVisible] = useState(false)
//   const [content, setContent] = useState<ReactNode | null>(null)
//   const showModal = (modalContent: ReactNode) => {
//     setContent(modalContent)
//     setVisible(true)
//   }
//   const hideModal = () => {
//     setVisible(false)
//     setContent(null)
//   }
//   return (
//     <ModalContext.Provider value={{ showModal, hideModal, content, visible }}>
//       {children}
//     </ModalContext.Provider>
//   )
// }

// export const useModal = () => useContext(ModalContext)

import { createContext, useContext, useState, ReactNode } from "react";

interface ModalOptions {
  width?: string | number;
  padding?: string;
  height?: string;
}

const ModalContext = createContext<{
  showModal: (content: ReactNode, options?: ModalOptions) => void;
  hideModal: () => void;
  content: ReactNode | null;
  visible: boolean;
  options: ModalOptions;
}>({
  showModal: () => {},
  hideModal: () => {},
  content: null,
  visible: false,
  options: {},
});

export const ModalProvider = ({ children }: { children: ReactNode }) => {
  const [visible, setVisible] = useState(false);
  const [content, setContent] = useState<ReactNode | null>(null);
  const [options, setOptions] = useState<ModalOptions>({});

  const showModal = (
    modalContent: ReactNode,
    modalOptions: ModalOptions = {}
  ) => {
    setContent(modalContent);
    setOptions(modalOptions);
    setVisible(true);
  };

  const hideModal = () => {
    setVisible(false);
    setContent(null);
    setOptions({});
  };

  return (
    <ModalContext.Provider
      value={{ showModal, hideModal, content, visible, options }}
    >
      {children}
    </ModalContext.Provider>
  );
};

export const useModal = () => useContext(ModalContext);
